
import { mapState } from 'vuex' // 引入mapState
import userHeader from './userHeader.vue' // 头部
import userCountry from './userCountry.vue' // 国家
import wikiGeet from './wikiGeet.vue' // 极验
export default {
  components: {
    'user-header': userHeader,
    'user-country': userCountry,
    'wiki-geet': wikiGeet
  },
  props: {
    email: {
      // 邮箱/账号
      type: [Number, String],
      default: ''
    },
    isregister: {
      // 邮箱是否注册
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false, // 接口请求中
      // isregister: true, // 是否为注册
      LanguageCode: this.$store.state.LanguageCode, // 当前页面语言
      fingerprint: this.$cookies.get('wiki-bfp'), // 浏览器指纹
      state: this.isregister ? 3 : 1, // 1为创建密码 2为绑定手机号 3为输入密码
      passwordState: false, // 第一次密码状态
      oncepasswordState: false, // 再次输入密码状态
      loginpasswordState: false, // 登录密码绑定
      phoneState: false, // 手机号状态
      smsState: false, // 验证码状态
      roTade: false, // 国家下拉
      countDown: 0, // 倒计时秒数
      iscountdown: false, // 是否显示验证码
      showDrag: false, // 极验是否展示
      product: 'bind', // 极验展示效果
      graphicalState: false, // 图形验证码是否展示
      seyes: false, // 密码眼睛状态
      twoseyes: false, // 再次密码眼睛状态
      loginseyes: false, // 登录眼睛状态
      register: {
        password: '', // 密码
        oncepassword: '', // 再次输入密码
        passwordError: '', // 密码错误提示
        phone: '', // 手机号
        phoneError: '', // 手机号错误
        sms: '', // 验证码
        smsError: '', // 验证码报错
        figuresmsError: '', // 图形验证码报错
        requestId: ''
      },
      loginpass: {
        // 登录数据绑定
        password: '', // 密码
        passwordError: '' // 密码错误提示
      }
    }
  },
  computed: {
    ...mapState(['usergetCountry']), // 选中的国家
    title() {
      // 标题
      switch (this.state) {
        case 1:
          return this.$v('创建密码')
        case 2:
          return this.$v('绑定手机号')
        case 3:
          return this.$v('输入密码')
        default:
          return this.$v('无头')
      }
    },
    btnState() {
      if (this.state == 1 && this.register.password.length > 5 && this.register.oncepassword.length > 5) {
        return true
      } else if (this.state == 2 && this.register.phone && this.register.sms) {
        return true
      } else if (this.state == 3 && this.loginpass.password.length > 5) {
        return true
      } else {
        return false
      }
    }
  },
  created() {},
  mounted() {
    document.addEventListener('click', this.coutryClose, { passive: true })
  },
  beforeDestroy() {
    document.removeEventListener('click', this.coutryClose)
  },
  methods: {
    countryChange(i) {
      this.register.phone = ''
      this.roTade = false
    },
    coutryClose(e) {
      // 点击非组件区域关闭下拉框
      if (!this.$el.contains(e.target)) this.roTade = false
    },
    login() {
      if (this.btnState) {
        if (this.state == 1) this.checkpassword()
        else if (this.state == 2) {
          if (this.sendcode()) {
            // 校验手机号是否通过
            if (this.loading) return
            this.loading = true
            // 判断是否为三方注册
            this.$route.query.type == 'register' ? this.triparphone(2) : this.registerLogin()
          }
        } else if (this.state == 3) this.$route.query.type == 'register' ? this.triparemaillogin() : this.emaillogin()
      }
    },
    async emaillogin() {
      // 邮箱登录
      if (this.loading) return
      this.loading = true
      const newusercenterloginv2 = await this.$api.common
        .CV3(
          {
            account: this.email, // 账号
            password: this.loginpass.password,
            version: 124, // 版本号
            loginType: this.email.includes('@') ? 1 : 0, // 0为手机 1为邮箱
            applicationType: 7, // 项目类型
            countryCode: this.usergetCountry.countryCode, // 国家code
            languageCode: this.LanguageCode, // 页面语言
            ip: this.$store.state.userIp // 用户ip
          },
          {
            Routes: 'usercenter$newusercenterloginv2'
          }
        )
        .catch(() => {
          console.log('newusercenterloginv2')
        })
      if (newusercenterloginv2 && newusercenterloginv2.usercenter && newusercenterloginv2.usercenter.newusercenterloginv2) {
        this.loading = false
        if (!newusercenterloginv2.usercenter.newusercenterloginv2.success) return (this.loginpass.passwordError = newusercenterloginv2.usercenter.newusercenterloginv2.extra)
        this.loginpass.passwordError = ''
        this.accessCookie(newusercenterloginv2.usercenter.newusercenterloginv2.data)
      }
      if (this.loading) {
        // 处理意外情况 接口报错
        setTimeout(() => {
          this.loading = false
        }, 5000)
      }
    },
    checkpassword() {
      // 密码下一步
      if (this.register.password != this.register.oncepassword) return (this.register.passwordError = this.$v('两次密码不一致'))
      else if (this.register.password.length < 6 || this.register.password.length > 20) return (this.register.passwordError = this.$v('密码为6-20位，不能包含汉字或空格'))
      this.register.passwordError = ''
      this.state = 2
    },
    async registerLogin() {
      // 注册 手机号验证通过
      console.log('注册')
      const emailregisterv3 = await this.$api.common
        .CV3(
          {
            areaCode: this.usergetCountry.code,
            password: this.register.password,
            passwordRepeat: this.register.oncepassword,
            areaFlag: this.usergetCountry.flag,
            phone: this.register.phone,
            Email: this.email,
            deviceInformation: 'web',
            version: 124,
            registrationPlatform: 0,
            deviceCode: this.fingerprint,
            msgCode: this.register.sms,
            registrationType: 311,
            applicationType: 7, // 项目类型
            countryCode: this.usergetCountry.countryCode, // 国家code
            languageCode: this.LanguageCode,
            registrationip: this.$store.state.userIp // 用户ip
          },
          {
            Routes: 'usercenter$emailregisterv3'
          }
        )
        .catch(() => {
          console.log('emailregisterv3')
        })
      console.log('emailregisterv3: ', emailregisterv3)
      if (emailregisterv3 && emailregisterv3.usercenter && emailregisterv3.usercenter.emailregisterv3) {
        this.loading = false
        if (!emailregisterv3.usercenter.emailregisterv3.success) return (this.register.smsError = emailregisterv3.usercenter.emailregisterv3.extra) // 数据错误
        this.register.smsError = ''
        this.accessCookie(emailregisterv3.usercenter.emailregisterv3.data)
      }
      if (this.loading) {
        // 处理意外情况 接口报错
        setTimeout(() => {
          this.loading = false
        }, 5000)
      }
    },
    back() {
      if (this.state == 1 || this.state == 3) {
        this.$emit('back', 1)
        this.seyes = this.twoseyes = this.loginseyes = this.loginseyes = false
        this.register.password = this.register.oncepassword = this.register.passwordError = this.loginpass.password = this.loginpass.passwordError = ''
      } else if (this.state == 2) {
        this.state = 1
        this.roTade = this.smsState = this.phoneState = this.showDrag = this.iscountdown = false
        this.register.phoneError = this.register.phone = this.register.smsError = this.register.sms = ''
      }
    },
    async getcode() {
      // 发送验证码
      if (!this.sendcode()) return
      const newusercentergetrepeatphonepasswordverifyv2 = await this.$api.common
        .CV3(
          {
            // 校验输入的密码是否使用过
            passWord: this.register.password,
            phone: this.register.phone,
            languageCode: this.LanguageCode,
            areaCode: this.usergetCountry.code,
            buinsessType: 2
          },
          {
            Routes: 'usercenter$newusercentergetrepeatphonepasswordverifyv2'
          }
        )
        .catch(() => {
          console.log('newusercentergetrepeatphonepasswordverifyv2')
        })
      if (newusercentergetrepeatphonepasswordverifyv2 && newusercentergetrepeatphonepasswordverifyv2.usercenter && newusercentergetrepeatphonepasswordverifyv2.usercenter.newusercentergetrepeatphonepasswordverifyv2) {
        if (!newusercentergetrepeatphonepasswordverifyv2.usercenter.newusercentergetrepeatphonepasswordverifyv2.success) {
          this.register.phoneError = newusercentergetrepeatphonepasswordverifyv2.usercenter.newusercentergetrepeatphonepasswordverifyv2.extra // 数据错误
          return
        }
        this.register.smsError = ''
        if (this.$route.query.type == 'register' && this.sendcode()) {
          this.triparphone(1)
        } else if (this.sendcode()) {
          this.showDrag = true // 极验框展示
          setTimeout(() => {
            this.showDrag = false
          }, 300)
        }
      }
    },
    async triparphone(i) {
      // 三方流程
      const thirdphoneverifyv3 = await this.$api.common
        .CV3(
          {
            AreaCode: this.usergetCountry.code,
            PhoneNubmer: this.register.phone,
            AccountType: this.$route.query.logintype
          },
          {
            Routes: 'usercenter$thirdphoneverifyv3'
          }
        )
        .catch(() => {
          console.log('thirdphoneverifyv3')
        })
      console.log('thirdphoneverifyv3: ', thirdphoneverifyv3)
      if (thirdphoneverifyv3 && thirdphoneverifyv3.usercenter && thirdphoneverifyv3.usercenter.thirdphoneverifyv3) {
        if (!thirdphoneverifyv3.usercenter.thirdphoneverifyv3.success) {
          this.register.phoneError = thirdphoneverifyv3.usercenter.thirdphoneverifyv3.extra
          this.loading = false
          return
        } // 数据错误
        this.register.phoneError = ''
        if (i == 1) {
          // 验证码点击
          this.showDrag = true // 极验框展示
          setTimeout(() => {
            this.showDrag = false
          }, 300)
        } else if (i == 2) {
          // 登录点击
          this.triparemaillogin()
        }
      }
      if (this.loading) {
        // 处理意外情况 接口报错
        setTimeout(() => {
          this.loading = false
        }, 5000)
      }
    },
    async triparemaillogin() {
      // 邮箱三方注册
      const thirdphoneverifyv3 = await this.$api.common
        .CV3(
          {
            openId: this.$route.query.id,
            accountNick: this.$route.query.name && this.$route.query.name != 'null' ? this.$route.query.name : '',
            accountHead: this.$route.query.img && this.$route.query.img != 'null' ? this.$route.query.img : '',
            accountType: this.$route.query.logintype,
            email: this.email,
            areaCode: this.usergetCountry.code,
            areaFlag: this.usergetCountry.flag,
            phone: this.register.phone,
            deviceInformation: 'web',
            version: 124,
            registrationPlatform: 0,
            deviceCode: this.fingerprint,
            msgCode: this.register.sms,
            registrationType: 311,
            applicationType: 7,
            countryCode: this.usergetCountry.countryCode,
            languageCode: this.LanguageCode,
            registrationip: this.$store.state.userIp,
            password: this.register.password || this.loginpass.password
          },
          {
            Routes: 'usercenter$thirdemialregisterv3'
          }
        )
        .catch(() => {
          console.log('thirdemialregisterv3')
        })
      if (thirdphoneverifyv3 && thirdphoneverifyv3.usercenter && thirdphoneverifyv3.usercenter.thirdemialregisterv3) {
        this.loading = false
        if (!thirdphoneverifyv3.usercenter.thirdemialregisterv3.success) {
          this.register.smsError = thirdphoneverifyv3.usercenter.thirdemialregisterv3.extra // 数据错误
          this.loginpass.passwordError = thirdphoneverifyv3.usercenter.thirdemialregisterv3.extra
          return
        }
        console.log('thirdphoneverifyv3: ', thirdphoneverifyv3)

        this.register.smsError = this.register.passwordError = ''
        this.accessCookie(thirdphoneverifyv3.usercenter.thirdemialregisterv3.data)
      }
    },
    sendcode() {
      // 获取验证码
      if (this.usergetCountry.code == '0086') {
        // 如果为国内则走国内手机号验证
        if (!this.register.phone) {
          this.register.phoneError = this.$v('手机号格式不正确')
          return false
        }
        const myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
        if (myreg.test(this.register.phone)) {
          // console.log('验证手机号成功')
          this.register.phoneError = '' // 验证成功则错误消息清空
          return true
        } else {
          this.register.phoneError = this.$v('手机号格式不正确')
          return false
        }
      } else {
        // 否则走国外手机号验证
        if (!this.register.phone) {
          this.register.phoneError = this.$v('手机号格式不正确')
          return false
        }
        const myreg = /^.{5,20}$/
        if (myreg.test(this.register.phone)) {
          this.register.phoneError = '' // 验证成功则错误消息清空
          return true
        } else {
          this.register.phoneError = this.$v('手机号格式不正确')
          return false
        }
      }
    },
    async sendVCode(data = {}) {
      // 极验成功后发送验证码
      const { phone = '' } = this.register // 手机号为空true/false
      if (!phone) return false
      const getnewsendcodev2 = await this.$api.common
        .CV3(
          {
            areaCode: this.usergetCountry.code,
            phone,
            languageCode: this.LanguageCode,
            msgType: 0,
            smsBusinessType: 8,
            applicationType: 7,
            GeetestValidate: data.geetest_validate,
            GeetestChallenge: data.geetest_challenge
          },
          {
            Routes: 'usercenter$newsendcodev2'
          }
        )
        .catch(() => {
          console.log('newsendcodev2')
        })
      if (getnewsendcodev2 && getnewsendcodev2.usercenter && getnewsendcodev2.usercenter.newsendcodev2) {
        if (!getnewsendcodev2.usercenter.newsendcodev2.success) return (this.register.smsError = getnewsendcodev2.usercenter.newsendcodev2.extra) // 数据错误
        this.register.smsError = ''
        this.register.requestId = getnewsendcodev2.usercenter.newsendcodev2.data.requestid
        this.showDrag = false // 隐藏拖拽框
        this.countDown = 60
        this.iscountdown = true // 是否开始倒计时
        this.startCount() // 开始倒计时
      }
    },
    async figuresms(sms) {
      // 图形验证码成功后发送验证码
      const { phone = '' } = this.register // 手机号为空true/false
      if (!phone) return false
      const getnewsendcodev2 = await this.$api.common
        .CV3(
          {
            areaCode: this.usergetCountry.code,
            phone,
            languageCode: this.LanguageCode,
            msgType: 0,
            smsBusinessType: 8,
            applicationType: 7,
            GeetestValidate: '',
            GeetestChallenge: '',
            graphCode: sms
          },
          {
            Routes: 'usercenter$newsendcodev2'
          }
        )
        .catch(() => {
          console.log('newsendcodev2')
        })
      if (getnewsendcodev2 && getnewsendcodev2.usercenter && getnewsendcodev2.usercenter.newsendcodev2) {
        if (!getnewsendcodev2.usercenter.newsendcodev2.success) return (this.register.figuresmsError = getnewsendcodev2.usercenter.newsendcodev2.extra) // 数据错误
        this.register.figuresmsError = '' // 错误置空
        this.graphicalState = false // 图形弹框关闭
        this.register.requestId = getnewsendcodev2.usercenter.newsendcodev2.data.requestid
        this.showDrag = false // 隐藏拖拽框
        this.countDown = 60
        this.iscountdown = true // 是否开始倒计时
        this.startCount() // 开始倒计时
      }
    },
    // 验证码登录——开始倒计时
    startCount() {
      this.countDown--
      if (this.countDown < 1) {
        // 倒计时结束
        clearTimeout(this.vTimer)
        this.countimes++
        this.iscountdown = false // 倒计时关闭
        return true
      }
      this.vTimer = setTimeout(this.startCount, 1000)
    },
    geetError() {
      // 极验错误
      console.log('极验错误')
      this.showDrag = false // 极验框状态取消
      this.graphicalState = true // 图形验证弹出
    },
    async accessCookie(userInfo) {
      // 加密cookie存cookie
      this.$store.commit('setUser', {
        userId: userInfo.userId,
        nick: userInfo.showNickName || userInfo.nick || userInfo.nickName,
        avatar: userInfo.showAvataraddress || userInfo.avatar || userInfo.profilePhoto
      })
      const getcookie = await this.$api.common
        .CV3(
          // 信息加密
          {
            userId: userInfo.userId,
            nick: userInfo.showNickName || userInfo.nick || userInfo.nickName,
            avatar: userInfo.showAvataraddress || userInfo.avatar || userInfo.profilePhoto
          },
          {
            Routes: 'usercenter$getcookie'
          }
        )
        .catch(() => {
          console.log('getcookie')
        })
      if (getcookie && getcookie.usercenter && getcookie.usercenter.getcookie) {
        if (!getcookie.usercenter.getcookie.success) return this.$message.error(getcookie.usercenter.getcookie.extra) // 数据错误
        if (this.$store.state.host.includes('wikifx')) {
          this.CookieSet('DJkdikKMG', getcookie.usercenter.getcookie.data.Value, `.${this.$store.state.host.split('.')[1]}.${this.getSuffix(this.$store.state)}`)
        } else if (this.$store.state.host.includes('fxeye')) {
          this.CookieSet('ViLartidlakd', getcookie.usercenter.getcookie.data.Value, `.${this.$store.state.host.split('.')[1]}.${this.getSuffix(this.$store.state)}`)
        } else {
          this.$cookies.set('WsdsfgDGdagYms', getcookie.usercenter.getcookie.data.Value)
          const postdata = {
            op_type: 'setCookie',
            url: '',
            parm: getcookie.usercenter.getcookie.data.Value
          }
          window.parent.postMessage(postdata, '*')
        }
      }
      this.$store.commit('setUsercookie', getcookie.usercenter.getcookie.data.Value)
      const postdata = {
        op_type: 'reload',
        url: '',
        parm: getcookie.usercenter.getcookie.data.Value
      }
      window.parent && window.parent.postMessage(postdata, '*')
      if (!this.isregister && userInfo.userStatus == 3) this.$emit('popjoinflow')
      else {
        this.$emit('close')
        if (this.$store.state.path.includes('login.html')) {
          setTimeout(() => {
            if (process.client) window.open(`https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/`)
          }, 1500)
        }
      }
    },
    CookieSet(key, val, dom) {
      // 存cookie
      const expiresTime = new Date(Date.now() + 8.64e7 * 999)
      this.$cookies.set(key, val, {
        expires: expiresTime,
        path: '/',
        domain: dom
      })
    }
  }
}
